/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Website_Feature_5Inputs */

const et_plan_website_feature_5 = /** @type {(inputs: Plan_Website_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobib hästi alustavale või uuenevale ettevõttele`)
};

const en_plan_website_feature_5 = /** @type {(inputs: Plan_Website_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Works well for a new or evolving business`)
};

/**
* | output |
* | --- |
* | "Works well for a new or evolving business" |
*
* @param {Plan_Website_Feature_5Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_website_feature_5 = /** @type {((inputs?: Plan_Website_Feature_5Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Website_Feature_5Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_website_feature_5(inputs)
	return en_plan_website_feature_5(inputs)
});